export enum VariableTemplate{
    NAME_CAMELS_CASE = "NAME_CAMELS_CASE",
    NAME_CAMELS_CASE_UPPER_FIRST = "NAME_CAMELS_CASE_UPPER_FIRST",
    NAME_SNACK_CASE = "NAME_SNACK_CASE",
    SEQUELIZE_MODEL = "SEQUELIZE_MODEL",
    INTERFACE = "INTERFACE"
}

export const variableTemplate = [
    {
        variable : VariableTemplate.NAME_CAMELS_CASE,
        preview : "nameTable"
    },
    {
        variable : VariableTemplate.NAME_CAMELS_CASE_UPPER_FIRST,
        preview : "NameTable"
    },
    {
        variable : VariableTemplate.NAME_SNACK_CASE,
        preview : "name_table"
    },
    {
        variable : VariableTemplate.SEQUELIZE_MODEL,
        preview : ` title: {
            type: DataTypes.STRING,
            primaryKey: true,
            allowNull: false,
            field: 'title',
          },
          content: {
            type: DataTypes.TEXT,
            field: 'content',
          }`
    },
    {
        variable : VariableTemplate.INTERFACE,
        preview : `title?: string;
        content?: string;`
    },
]